import { render, staticRenderFns } from "./NiifNoControlante.vue?vue&type=template&id=263a5a10"
import script from "./NiifNoControlante.vue?vue&type=script&lang=js"
export * from "./NiifNoControlante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports